import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip, Badge,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import { LargeModal } from "components/Common/LargeModal"
import {convertToDateTimeString, hasPermission, numberWithCommas} from "../../../helpers/helpers";
import {deleteJackpot} from "../../../store/jackpots/actions";
import * as moment from "moment";
function Table(props) {
  const [isOpen, setIsOpen] = useState(false)

  const { data } = props
  const columns = [
    {
      dataField: "id",
      text: "JackpotId",
      sort: true,
    },
    {
      dataField: "name",
      text: "JackpotName",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Created Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "250px" }
      },
      formatter: (cellContent, row) => {
        return <>{convertToDateTimeString(row?.created_at)}</>
      },
    },
    {
      text: "Market",
      dataField: "market",
      sort: true,
    },
    {
      text: "Prizes",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
          <>
            <p className="mb-1 fw-bold">{numberWithCommas(row?.max_price)}</p>
            <p className="mb-0 fw-bold">{numberWithCommas(row?.n_1)}</p>
            <p className="mb-0 fw-bold">{numberWithCommas(row?.n_2)}</p>
          </>
      ),
    },
    {
      dataField: "price_per_ticket",
      text: "JP Prize",
      sort: true,
      formatter: (cellContent, row) => (
          <>
            <p>{numberWithCommas(row?.price_per_ticket)}</p>
          </>
      ),
    },
    {
      dataField: "stake",
      text: "Stake",
      sort: true,
      formatter: (cellContent, row) => (
          <>
            <p>{numberWithCommas(row?.stake)}</p>
          </>
      ),
    },
    {
      dataField: "total_player",
      text: "Total Players",
      sort: true,
      formatter: (cellContent, row) => (
          <>
            <p>{row?.total_player}</p>
          </>
      ),
    },
    {
      dataField: "total_stake",
      text: "Total Stake",
      sort: true,
      formatter: (cellContent, row) => (
          <>
            <p>{numberWithCommas(row?.total_stake)}</p>
          </>
      ),
    },
    {
      dataField: "total_payout",
      text: "Total Payout",
      sort: true,
      formatter: (cellContent, row) => (
          <>
            <p>{numberWithCommas(row?.total_payout)}</p>
          </>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]
  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: data?.length,
    custom: true,
  }


  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Jackpot Tickets"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="6">
                            <div>
                              <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`Jackpot-Report-${moment(new Date()).format("DD/MM/YYYY")}`}

                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable id="table-to-xls"
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            //   selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>

    </>
  )
}

export default withRouter(Table)
